export const wrap = (value, mutate) => ({ value, mutate });
